import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getSession } from 'next-auth/react';

const cache = new InMemoryCache({
  possibleTypes: {
    Schedule: ['ScheduleCreated', 'ScheduleUnderCreation', 'ScheduleCreationFailed', 'ScheduleNotAvailable'],
  },
  typePolicies: {
    Plan: {
      keyFields: ['id'],
    },
  },
});

const authLink = setContext(async (_, { headers }) => {
  const session = await getSession();
  const idToken = session?.user?.token?.idToken;

  return {
    headers: {
      ...headers,
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
  };
});

const httpLink = createHttpLink({
  credentials: 'omit',
  uri: '/proxy/graphql',
  useGETForQueries: true,
});

export const apolloClientCsr = new ApolloClient({
  cache,
  defaultContext: { fetchOptions: { next: { revalidate: 5 } } },

  defaultOptions: {
    query: {
      errorPolicy: 'all',
    },
  },
  link: authLink.concat(httpLink),
});
